module.exports = __webpack_public_path__ + "static/media/goldenprize-sardine-tomato.8282a985.png";